/* fh-motion.js — global scroll-reveal engine for the fh-* layer.
   The no-flash `fh-anim` toggle is set synchronously in <head> (custom-assets) BEFORE paint,
   gated by reduced-motion + IntersectionObserver support. This file only binds the observer.
   Reveals via opacity/transform/clip-path only (GPU). Reduced-motion users never get fh-anim → all visible. */
(function () {
  if (!document.documentElement.classList.contains('fh-anim')) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.14, rootMargin: '0px 0px -60px 0px' });
  function bind() {
    document.querySelectorAll('.fh-reveal:not(.is-in), [data-fh-lines]:not(.is-in)').forEach(function (el) { io.observe(el); });
  }
  if (document.readyState !== 'loading') bind();
  else document.addEventListener('DOMContentLoaded', bind);
})();
